import CheckoutDetails from "../components/CheckoutDetails/CheckoutDetails";

const Checkout = () => <CheckoutDetails />;

export default Checkout;
